import { defineMessages } from 'react-intl-next';

export default defineMessages({
    searchButton: {
        defaultMessage: 'Submit search query',
        description: 'Accessible text for the Submit button that is used to show the search.',
        id: 'cv.search.search-textbox.search-button',
    },
    close: {
        defaultMessage: 'Close search',
        description: 'Label for the close button which closes the search overlay',
        id: 'cv.search.search-textbox.close',
    },
    inputLabel: {
        defaultMessage: 'search textbox input',
        description: 'Text for the search textbox input label',
        id: 'cv.search.search-textbox.input-label',
    },
});
